"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Label = Label;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Label(props) {
  var className = props.className,
      htmlFor = props.htmlFor,
      children = props.children,
      isPageHeading = props.isPageHeading,
      attributes = _objectWithoutProperties(props, ["className", "htmlFor", "children", "isPageHeading"]);

  var label =
  /*#__PURE__*/
  // Stop eslint flagging the for/id combination as an error. It is failing due to the way the
  // input and label are located in different components and so it cannot track the association
  //
  // eslint-disable-next-line jsx-a11y/label-has-for
  _react["default"].createElement("label", _extends({
    className: "govuk-label ".concat(className || '')
  }, attributes, {
    htmlFor: htmlFor
  }), children);

  if (isPageHeading === true) {
    return /*#__PURE__*/_react["default"].createElement("h1", {
      className: "govuk-label-wrapper"
    }, label);
  }

  return label;
}